import type { PropsWithChildren } from 'react';

import { ClassProvider } from './ClassContext';
import Loadable from '../components/common/loadable';
import { getUrlParams } from '../utils/url';

// Note: optional
export type LegacyRecordingsProviderProps = PropsWithChildren<{}>;

const LegacyRecordingsProvider = (props: LegacyRecordingsProviderProps) => {
    const { children } = props;

    const { class_uuid: classUuid } = getUrlParams();
    if (!classUuid) {
        console.error('"class_uuid" is missing from url params!');
        return <Loadable isLoading fullScreen />;
    }

    return <ClassProvider classUuid={classUuid}>{children}</ClassProvider>;
};

export { LegacyRecordingsProvider };
